import React, { useState, useRef, useEffect } from 'react';
const ChatComponent = ({ messages, setMessages, onSendMessage }) => {
  const [newMessage, setNewMessage] = useState('');
  const messagesContainerRef = useRef(null);

  useEffect(() => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
    }
  }, [messages]);

  const sendMessage = () => {
    if (newMessage.trim() !== '') {
      setMessages((prevMessages) => [
        ...prevMessages,
        { message: newMessage, sender: 'user' },
        { message: 'Enviando mensagem..', sender: 'Chat GPT' },
      ]);
      onSendMessage(newMessage);

      setNewMessage('');
    }
  };

  return (
    <div style={{ padding: '10px', width: '100%', height: '80vh', display: 'flex', flexDirection: 'column' }}>
      <div
        ref={messagesContainerRef}
        style={{
          flex: 1,
          overflowY: 'auto',
          marginBottom: '10px',
          borderRadius: '0',
          border: '1px solid #ccc',
          padding: '5px',
          scrollBehavior: 'smooth',
          boxSizing: 'border-box',
        }}
      >
        {messages.map((message, index) => (
          <div key={index} style={{ marginBottom: '20px', padding:'10px', width: '100%', textAlign: message.user == 'IA Customer Voice' ? 'left' : 'right' }}>
          {message.user === 'IA Customer Voice' ? (
              <div style={{ fontSize:'0.8em', color: message.user === 'IA Customer Voice' ? '#2b6cb0' : '#66b2ff', marginBottom: '1px' }}>{message.user}</div>
            ) : (
              <div style={{ fontSize:'0.8em', color: message.user === 'IA Customer Voice' ? '#2b6cb0' : '#66b2ff', marginBottom: '1px' }}>{message.user}</div>
            )}
            <div
              class='highlightStyle'
              style={{
                padding: '10px',
                backgroundColor: message.user === 'IA Customer Voice' ? '#d8f0ff' : '#eef9ff', 
                borderRadius: '10px',
                color: message.user === 'IA Customer Voice' ? 'black' : 'black',
                display: 'inline-block',
                textAlign: message.user === 'IA Customer Voice' ? 'left' : 'right',
                filter: message.user === 'IA Customer Voice' ? 'brightness(90%)' : 'none',
              }}
            >
              {message.message}
            </div>
            
          </div>
        ))}
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="text"
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          placeholder="Digite sua mensagem..."
          style={{
            flex: 1,
            padding: '10px',
            border: 'none',
            borderRadius: '4px',
            backgroundColor: '#e9e9e9',
            color: 'black',
            marginRight: '10px',
            outline: 'none',
          }}
        />
        <button
          onClick={sendMessage}
          style={{
            padding: '10px',
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          Enviar
        </button>
      </div>
    </div>
  );
};

export default ChatComponent;